// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingToggle_root__hJGWI","subtitle":"SettingToggle_subtitle__sPgoz","title":"SettingToggle_title__rT7Zq","list":"SettingToggle_list__K01Gl"};